import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {TreeListItem} from '../../interfaces/tree-list-item.model';
import {BegrotingService} from '../../services/begroting.service';
import { ProgramService } from '../../services/program.service';

@Component({
  selector: 'app-list-modal',
  templateUrl: './list-modal.component.html',
  styleUrls: ['./list-modal.component.scss']
})
export class ListModalComponent implements OnInit {
list: TreeListItem[] = [ ];
type: number;
title: string;
  program: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private begrotingsService: BegrotingService,
    private service: ProgramService
    ) { }

  ngOnInit() {

    this.route.data.subscribe(a => {
      this.type = (a['type']);

      if (this.type === 1) { // Begrotingswijzigingen

        this.title = 'Beleidskaders';


        this.route.parent.params
          .switchMap((params: Params) => this.service.getProgram(+params['id']))
          .subscribe((a) => {
            if (a !== undefined) {
              this.program = a;
              this.title = `Beleidskaders - ${a.Weergavenummer}. ${a.naam}`;
            }
          });


        this.route.parent.params
          .switchMap((params: Params) => this.begrotingsService.get(+params['id']))
          .subscribe((a) => {
            this.list = a.map(b => {
              return <TreeListItem>{
                text: b.titel,
                subtext: b.omschrijving,
                link: b.url
              }
            });
          });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/list-modal/list-modal.component.ts